import { useRef, useState } from 'react'

import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { interfaces } from 'service/interfaces'

import Form from './Form'

const NewVehicle = (props) => {
  const { handleClose, open, changeRender, idSelected } = props
  const formSubmitRef = useRef(null)
  const createDismissableSnackbar = useCustomSnackbar()
  const handleSubmit = () => {
    formSubmitRef.current.click()
  }

  const [loading, setLoading] = useState(false)
  const onSubmit = async (values) => {
    setLoading(true)
    const value = {
      dominio: values.dominio.toUpperCase(),
      marca: values.marca.toUpperCase(),
      modelo: values.modelo.toUpperCase(),
      tipo: values.tipo,
      transporte_id: idSelected,
    }
    await interfaces.configInterface
      .newVehicle(value)
      .then((res) => {
        createDismissableSnackbar(res.data, {
          variant: 'success',
        })
        changeRender()
      })
      .catch((error) =>
        createDismissableSnackbar(error.response.data.data, {
          variant: 'error',
        })
      )
      .finally(handleClose)
    setLoading(false)
  }

  return (
    <div>
      <DialogComponent
        open={open}
        handleclose={handleClose}
        handleclosedisabled={loading}
        widthLarge="500px"
        title="Nuevo vehiculo"
        children={<Form ref={formSubmitRef} onSubmit={onSubmit} />}
        disableChildHeight
        disableBackdropClick
        disableEscapeKeyDown
        actions={
          <>
            <CancelConfirmButtons
              onClickCancel={handleClose}
              onClickSubmit={handleSubmit}
              disabledCancel={loading}
              disabledSubmit={loading}
              isLoading={loading}
            />
          </>
        }
      />
    </div>
  )
}

export default NewVehicle
